/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Action_Stock_OutInputs */

const vi_order_action_stock_out = /** @type {(inputs: Order_Action_Stock_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất kho`)
};

/**

* @param {Order_Action_Stock_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_action_stock_out = /** @type {((inputs?: Order_Action_Stock_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Action_Stock_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_action_stock_out(inputs)
});